const CompanyMapping = [
  {
    id: "Octant",
    year: "2017",
    website: "https://www.octant.bio/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Octant engineers human cells to </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">act as reporters, turning on the </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">expression of a genetic barcode if a </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">particular drug target is activated. </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">This allows measuring drug effects </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">on cells and understanding which </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">pathways have been affected.</tspan>`,
    group: "DNA/RNA",
    rect: {
      x: "698.831",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Nabla",
    year: "2020",
    website: "https://www.nabla.bio/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Nabla designs new antibodies not </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">seen in nature through the use of </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">protein language modeling. Data </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">generated through multiplex </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">testing is used to train ML models, </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">which in turn are used to predict </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">biophysical properties from protein </tspan><tspan x="0" y="136.8" fill="#434242" font-family="Montserrat" font-size="12px">sequences. </tspan>`,
    group: "ANTIBODIES",
    rect: {
      x: "1215.057",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "BigHat",
    year: "2019",
    website: "https://www.bighatbio.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">BigHat is developing a combined </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">experimental and computational </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">antibody design platform. A </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">high-speed wet lab builds and tests </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">in silico designs, while ML guides </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">the design process to ultimately </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">optimize biophysical and functional </tspan><tspan x="0" y="136.8" fill="#434242" font-family="Montserrat" font-size="12px">characteristics.</tspan>`,
    group: "ANTIBODIES",
    rect: {
      x: "1161.979",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Dyno",
    year: 2018,
    website: "https://www.dynotx.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Dyno combines machine learning </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">and quantitative high-throughput </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">in vivo experimentation to design </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">novel gene therapy vectors, with a </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">focus on cell-targeting capsid </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">proteins from adeno-associated </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">virus (AAV).</tspan>`,
    group: "VECTORS",
    rect: {
      x: "1393.764",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "EVQLV",
    year: 2019,
    website: "https://evqlv.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">EVQLV&apos;s algorithms start from an </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">input of amino acid sequences to </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">computationally generate </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">evolutionarily possible antibodies </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">with high affinity and lower </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">likelihood of failure - mimicking the </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">natural selection inherent to </tspan><tspan x="0" y="136.8" fill="#434242" font-family="Montserrat" font-size="12px">antibody formation.</tspan>`,
    group: "ANTIBODIES",
    rect: {
      x: "1161.979",
      y: "216.518",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Hexagon",
    year: 2016,
    website: "https://www.hexagonbio.com/",
    description: `<tspan x="0" y="36" fill="#424242" font-family="Montserrat" font-size="12px">Hexagon is building a platform that </tspan><tspan x="0" y="50.4" fill="#424242" font-family="Montserrat" font-size="12px">combines machine learning, </tspan><tspan x="0" y="64.8" fill="#424242" font-family="Montserrat" font-size="12px">genomics, and synthetic biology to </tspan><tspan x="0" y="79.2" fill="#424242" font-family="Montserrat" font-size="12px">mine fungal genomes and discover </tspan><tspan x="0" y="93.6" fill="#424242" font-family="Montserrat" font-size="12px">evolutionarily refined small </tspan><tspan x="0" y="108" fill="#424242" font-family="Montserrat" font-size="12px">molecules alongside their protein </tspan><tspan x="0" y="122.4" fill="#424242" font-family="Montserrat" font-size="12px">targets. </tspan>`,
    group: "DNA/RNA",
    rect: {
      x: "751.909",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Pepticom",
    year: "2011",
    website: "https://pepticom.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Pepticom is developing an ML </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">platform for optimizing peptide </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">drug candidates. Starting from a </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">structure of the target protein, the </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">platform selects potential binding </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">areas and designs peptides </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">through consecutive reinforcement </tspan><tspan x="0" y="136.8" fill="#434242" font-family="Montserrat" font-size="12px">learning iterations.</tspan>`,
    group: "PEPTIDES",
    rect: {
      x: "520.174",
      y: "216.518",
      width: "50.061",
      height: "50.061",
    },
  },


  {
    id: "AI protein",
    year: "2021",
    website: "https://aiproteins.bio/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">AI protein designs and engineers </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">synthetic miniprotein therapeutics. </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">Computational  protein design </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">helps construct libraries that are </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">then screened for the best </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">candidates. Biophysical properties </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">are then characterized to minimize </tspan><tspan x="0" y="136.8" fill="#434242" font-family="Montserrat" font-size="12px">late stage failures.</tspan>`,
    group: "PEPTIDES",
    rect: {
      x: "467.096",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Menten",
    year: "2018",
    website: "https://www.menten.ai/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Menten combines machine </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">learning and quantum computing </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">to design and modify peptide </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">therapeutics for cancer and </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">neurodegenerative diseases, </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">generating new protein structures </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">through intentional designs as </tspan><tspan x="0" y="136.8" fill="#434242" font-family="Montserrat" font-size="12px">opposed to random trials.</tspan>`,
    group: "PEPTIDES",
    rect: {
      x: "467.096",
      y: "216.518",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Nuritas",
    year: "2014",
    website: "https://www.nuritas.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Nuritas combines AI, genomics, and </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">peptidomics to discover bioactive </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">peptides in plants and natural food </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">sources. The platform analyzes </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">these peptides to predict how they </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">may impact molecular pathways </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">and receptors.</tspan>`,
    group: "PEPTIDES",
    rect: {
      x: "573.251",
      y: "216.518",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Unnatural Products",
    year: "2017",
    website: "https://www.unnaturalproducts.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Unnatural Products is using </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">machine learning with massively </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">parallel chemical synthesis to </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">discover new macrocycle drugs. </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">Their platform combines prediction </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">with experiment in learning loops </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">to engineer synthetic molecules for </tspan><tspan x="0" y="136.8" fill="#434242" font-family="Montserrat" font-size="12px">undruggable targets.</tspan>`,
    group: "PEPTIDES",
    rect: {
      x: "520.174",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "ProteinQure",
    year: "2017",
    website: "https://www.proteinqure.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">ProteinQure is combining </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">high-performance computing, </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">molecular simulations, and </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">machine learning to design and </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">optimize peptide therapeutics for </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">binding, specificity, and other </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">pharmacokinetic properties.</tspan>`,
    group: "PEPTIDES",
    rect: {
      x: "573.251",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Vilya",
    year: "2022",
    website: "https://vilyatx.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Vilya&apos;s computational platform </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">combines synthetic chemistry and </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">machine learning to tap into </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">uncharted chemical space and </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">design de novo, </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">membrane-permeable, and orally </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">bioavailable macrocyclic peptides.</tspan>`,
    group: "PEPTIDES",
    rect: {
      x: "626.437",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },
  {
    id: "Sestina",
    year: "2021",
    website: "https://www.sestinabio.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Sestina is developing a platform for </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">automated synthetic biology </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">combining genome editing, single </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">cell biology, and machine learning </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">to navigate complex biological </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">space and produce better strains.</tspan>`,
    group: "DNA/RNA",
    rect: {
      x: "751.909",
      y: "216.518",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Sherlock",
    year: "2019",
    website: "https://sherlock.bio/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Sherlock leverages CRISPR,</tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">synthetic biology, and machine </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">learning to create molecular </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">diagnostics that can rapidly deliver </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">accurate results and are simple to </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">use for a vast range of needs.</tspan>`,
    group: "DNA/RNA",
    rect: {
      x: "698.831",
      y: "216.518",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Inceptive",
    year: "2021",
    website: "https://www.inceptive.life/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Inceptive combines AI and RNA </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">biology to design novel RNA </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">therapeutics. Their platform </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">integrates machine learning with </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">high-throughput experimentation </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">to optimize RNA drug design.</tspan>`,
    group: "DNA/RNA",
    rect: {
      x: "804.987",
      y: "216.518",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Atomic",
    year: "2021",
    website: "https://atomic.ai/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Atomic AI uses machine learning </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">and structural biology to map </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">RNA 3D structures and design </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">small molecule therapeutics that </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">target RNA. Their platform enables </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">precision targeting of RNA biology.</tspan>`,
    group: "DNA/RNA",
    rect: {
      x: "804.987",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Aether",
    year: "2017",
    website: "https://www.aetherbio.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Aether is building a high </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">throughput robotic factory to </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">generate data and ultimately train </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">ML algorithms to predict which </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">sequences of amino acids will </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">produce industrially useful enzymes </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">for creating synthetic substances.</tspan>`,
    group: "ENZYMES",
    rect: {
      x: "930.285",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Bota",
    year: "2021",
    website: "https://www.bota.bio/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Bota integrates advanced digital </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">tools, machine learning, and lab </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">automation to achieve scale effects </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">in experiment design and </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">accelerate the design and evolution </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">of enzymes and cell-based factories.</tspan>`,
    group: "ENZYMES",
    rect: {
      x: "930.285",
      y: "216.518",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Enzymit",
    year: "2020",
    website: "https://www.enzymit.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Enzymit leverages computational </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">design, deep learning, and high </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">throughput screening to design </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">novel enzymes and new metabolic </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">pathways - combined with cell-free </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">enzymatic manufacturing </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">technology.</tspan>`,
    group: "ENZYMES",
    rect: {
      x: "983.362",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "1910",
    year: "2018",
    website: "https://1910genetics.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">1910 Genetics&apos; ROSALYND platform </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">integrates AI, computation, and </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">automation to accelerate the </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">design of de novo protein </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">therapeutics and provide a more </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">affordable and accurate alternative </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">to X-ray crystallography.</tspan>`,
    group: "ANTIBODIES",
    rect: {
      x: "1215.057",
      y: "216.518",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "LabGenius",
    year: "2012",
    website: "https://labgeni.us/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">LabGenius is combining robotic </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">automation, synthetic biology, and </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">machine learning to describe </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">sequence to function relationships, </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">explore protein fitness landscapes, </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">and improve multiple drug </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">properties simultaneously.</tspan>`,
    group: "ANTIBODIES",
    rect: {
      x: "1268.135",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Chai",
    year: "2023",
    website: "https://www.chaidiscovery.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Chai Discovery builds frontier AI </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">models to predict and reprogram </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">biochemical interactions. Their </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">Chai-2 model achieves fully de </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">novo antibody design with 16-20% </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">hit rates, enabling rapid iteration </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">and accelerated development.</tspan>`,
    group: "ANTIBODIES",
    rect: {
      x: "1321.212",
      y: "216.518",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "MAbSilico",
    year: "2017",
    website: "https://mabsilico.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">MabSilico is developing AI </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">technology for antibody </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">development spanning lead </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">identification, characterization, and </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">optimization - leading to </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">accelerated development times </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">from several years to a few days.</tspan>`,
    group: "ANTIBODIES",
    rect: {
      x: "1268.135",
      y: "216.518",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "A-Alpha",
    year: "2017",
    website: "https://www.aalphabio.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">A-Alpha Bio combines synthetic </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">biology, structural biology, </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">next-generation sequencing, and </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">machine learning to measure </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">protein-protein interactions and </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">discover rare antibodies, identify </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">degradable neo-substrates, and </tspan><tspan x="0" y="136.8" fill="#434242" font-family="Montserrat" font-size="12px">engineer protein interfaces.</tspan>`,
    group: "ANTIBODIES",
    rect: {
      x: "1321.212",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Apertura",
    year: "2021",
    website: "https://aperturagtx.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Apertura uses proprietary assays </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">and machine learning to design </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">custom AAV capsids that have the </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">chosen characteristics for treating </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">specific diseases, while also </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">simultaneously engineering gene </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">regulatory elements and payloads.</tspan>`,
    group: "VECTORS",
    rect: {
      x: "1393.764",
      y: "216.518",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Capsida",
    year: "2019",
    website: "https://capsida.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Capsida&apos;s AAV engineering </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">platform uses machine learning, </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">structural biology, non-human </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">primate models, and human tissue </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">models to generate capsids </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">optimized to target specific tissues </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">and cells in disease organs.</tspan>`,
    group: "VECTORS",
    rect: {
      x: "1446.841",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Affina",
    year: "2019",
    website: "https://www.affiniatx.com/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Affina combines synthetic and </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">systems biology, high-throughput </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">screening, and machine learning to </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">rationally design AAV capsids and </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">identify correlates between </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">performance and capsid structure. </tspan>`,
    group: "VECTORS",
    rect: {
      x: "1446.841",
      y: "216.518",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Replay",
    year: "2021",
    website: "https://replay.bio/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Replay combines genome writing </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">technology and evolutionary </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">inference machine learning </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">algorithms to efficiently navigate </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">the sequence space and develop </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">high-capacity vectors for gene </tspan><tspan x="0" y="122.4" fill="#434242" font-family="Montserrat" font-size="12px">therapy.</tspan>`,
    group: "VECTORS",
    rect: {
      x: "1499.919",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Medium",
    year: "2021",
    website: "http://medium.bio/",
    description: `
    <tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Medium Biosciences is developing</tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">a software platform for industrial</tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">biotechnology companies to</tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">interface with machine learning </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">models for enzyme engineering. </tspan>`,
    group: "ENZYMES",
    rect: {
      x: "983.362",
      y: "216.518",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Xyme",
    year: "2022",
    website: "https://www.xyme.ai/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Xyme uses AI and machine learning </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">to design novel enzymes with </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">enhanced catalytic properties. Their </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">platform combines computational </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">design with high-throughput </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">screening for industrial applications.</tspan>`,
    group: "ENZYMES",
    rect: {
      x: "1036.44",
      y: "163.44",
      width: "50.061",
      height: "50.061",
    },
  },

  {
    id: "Ligo",
    year: "2021",
    website: "https://ligo.bio/",
    description: `<tspan x="0" y="36" fill="#434242" font-family="Montserrat" font-size="12px">Ligo develops computational tools </tspan><tspan x="0" y="50.4" fill="#434242" font-family="Montserrat" font-size="12px">for enzyme engineering, combining </tspan><tspan x="0" y="64.8" fill="#434242" font-family="Montserrat" font-size="12px">AI with biophysical modeling to </tspan><tspan x="0" y="79.2" fill="#434242" font-family="Montserrat" font-size="12px">predict protein function. Their </tspan><tspan x="0" y="93.6" fill="#434242" font-family="Montserrat" font-size="12px">platform accelerates the discovery </tspan><tspan x="0" y="108" fill="#434242" font-family="Montserrat" font-size="12px">of novel biocatalysts.</tspan>`,
    group: "ENZYMES",
    rect: {
      x: "1036.44",
      y: "216.518",
      width: "50.061",
      height: "50.061",
    },
  },
]

export default CompanyMapping
